export default __webpack_public_path__ + "static/media/placeholder.5ca44a61.jpg";